module.exports = __webpack_public_path__ + "static/img/logo-home.88b78c35.png";